import {
  accountsHttpService,
  authService,
  conversationHttpService,
  conversationStreamClient,
  httpService,
  miceHttpService,
  sseClient,
} from '@web/data/services';
import { createAdminApiKeysRepository } from './admin/api_keys_repository';
import { createAdminIntegrationsRepository } from './admin/integrations_repository';
import { createFlightAlertsRepository } from './alerts/flight_alerts_repository';
import { createAuthRepository } from './auth/auth_repository';
import { createBoardRepository } from './board/board_repository';
import { createConversationRepository } from './conversation/conversation_repository';
import { createMiceRepository } from './mice/mice_repository';
import { createMembersRepository } from './members/members_repository';
import { createMeRepository } from './me/me_repository';
import { createOverviewRepository } from './overview/overview_repository';
import { createProjectsRepository } from './project/project_repository';
import { createSquadsRepository } from './project/squad_repository';
import { createProjectMembersRepository } from './project/project_members_repository';
import { createRealtimeRepository } from './realtime/realtime_repository';
import { createSearchRepository } from './search/search_repository';
import { createCustomerSearchRepository } from './search/customer_search_repository';
import { createCustomerDossierRepository } from './customer/customer_dossier_repository';
import { createScheduleChangeRepository } from './schedule_change/schedule_change_repository';
import { createTriageRepository } from './settings/triage_repository';
import { createTriageInboxRepository } from './triage/triage_inbox_repository';
import { createTripRepository } from './trip/trip_repository';
import { createViewAsRepository } from './view_as/view_as_repository';
import { createTravelerAccessRepository } from './view_as/traveler_access_repository';

export const authRepository = createAuthRepository(authService);
export const conversationRepository = createConversationRepository(
  conversationHttpService,
  conversationStreamClient,
);
export const projectsRepository = createProjectsRepository(httpService);
export const squadsRepository = createSquadsRepository(httpService);
export const projectMembersRepository = createProjectMembersRepository(httpService);
export const meRepository = createMeRepository(accountsHttpService);
export const boardRepository = createBoardRepository(httpService);
export const membersRepository = createMembersRepository(accountsHttpService);
export const adminApiKeysRepository = createAdminApiKeysRepository(accountsHttpService);
export const adminIntegrationsRepository = createAdminIntegrationsRepository(httpService);
export const flightAlertsRepository = createFlightAlertsRepository(httpService);
export const overviewRepository = createOverviewRepository(httpService);
export const triageRepository = createTriageRepository(httpService);
export const triageInboxRepository = createTriageInboxRepository(httpService);
export const searchRepository = createSearchRepository(httpService);
export const customerSearchRepository = createCustomerSearchRepository(httpService);
export const customerDossierRepository = createCustomerDossierRepository(httpService);
export const tripRepository = createTripRepository(httpService);
export const viewAsRepository = createViewAsRepository(httpService);
export const travelerAccessRepository = createTravelerAccessRepository(httpService);
export const scheduleChangeRepository = createScheduleChangeRepository(authService);
export const miceRepository = createMiceRepository(miceHttpService, authService);
export const realtimeRepository = createRealtimeRepository(sseClient);

export { useAuthStore } from './auth/auth_store';
export { useCommandPalette } from './command_palette/command_palette_store';
export { useSidebarCollapsed } from './sidebar/sidebar_store';
export { useCreateCardPrefs } from './alerts/create_card_prefs_store';
export {
  FlightAlertsDisabledError,
  type FlightAlertsFilters,
} from './alerts/flight_alerts_repository';
export type { ProjectWithPermissions } from './project/project_repository';
export type { Me, MeUser, OrgEntry, UpdateMeInput } from './me/me_repository';
export type {
  ConversationBoardResponse,
  TaskBoardResponse,
  TaskWithCard,
  BoardConfigResponse,
  UpdateBoardConfigInput,
} from './board/board_repository';
export type {
  MemberDetail,
  MemberRole,
  MemberStatus,
  OrganizationRecord,
} from './members/members_repository';
export type { AdminApiKeyDto, AdminProviderDto } from './admin/api_keys_repository';
export type {
  ChatConnectionState,
  ChatConnectLinkCreateResponse,
  ChatProvider,
  IntegrationCompany,
  IntegrationPendingResponse,
} from './admin/integrations_repository';
export type { TriageConfigResponse, UpdateTriageConfigInput } from './settings/triage_repository';
export type { ViewAsHit, ViewAsSession } from './view_as/view_as_repository';
export type {
  AccessEvent,
  AccessGrant,
  TravelerAccessFilter,
} from './view_as/traveler_access_repository';
